// extracted by mini-css-extract-plugin
export default {"crossBtn":"ModeratorNotes_crossBtn__fFILd"};